document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', e => {
    if (e.target.matches('#live-chat-cta')) {
      e.preventDefault();
      document.querySelector('button#transparent-button')?.click();
    }
  });
});
